﻿//TN 20221116
import ActivePage from "../activePage";

export default class BusinessUnitPage extends ActivePage {

    constructor() {
        super();
        this.contactLettersFilter = {};
        this.currentLetterEntryContact = 0;
        this.businessUnitContactLetterEditMode = false;
        this.lastSelectedContactRow = null;
        this.businessUnitContactLettersContainer = "businessUnitContactLetters";
        this.lastSelectedContact = null;
        this.lastSelectedLetter = null;

    }

    initialize(businessUnitId, pageId) {
        //this.editableGrids = [
        //    {
        //        name: 'businessUnitContactsGrid', isDirty: false, filter: { businessUnitId: businessUnitId }, afterSubmit: this.updateRecordStamps
        //    },
        //    {
        //        name: 'businessUnitContactLettersGrid', isDirty: false, filter: this.getContactLettersFilter,
        //        afterSubmit: this.contacts_resetEditedFlag,
        //        onDirty: () => { this.businessUnitContactLetterEditMode = true; },
        //        onCancel: this.contacts_resetEditedFlag
        //    },
        //    {
        //        name: `reviewerSettingsGrid_${pageId}`, isDirty: false, filter: { parentId: businessUnitId, entityType: entityType }, afterSubmit: this.updateRecordStamps
        //    }
        //];

        $(document).ready(() => {
            //const businessUnitContactsGrid = $("#businessUnitContactsGrid");

            //businessUnitContactsGrid.on("click", ".contactLink", (e) => {
            //    e.stopPropagation();

            //    let url = $(e.target).data("url");
            //    const row = $(e.target).closest("tr");
            //    const dataItem = businessUnitContactsGrid.data("kendoGrid").dataItem(row);
            //    const linkUrl = url.replace("actualValue", dataItem.ContactID);
            //    pageHelper.openLink(linkUrl, false);
            //});

            //businessUnitContactsGrid.on("click", ".letter-entry", (e) => {
            //    e.stopPropagation();

            //    const element = $(e.target);
            //    const businessUnitId = element.data("businessUnit-id");
            //    const contactId = element.data("contact-id");

            //    if (!this.businessUnitContactLetterEditMode) {
            //        const parentRow = element.parents("tr.k-state-selected");
            //        if (parentRow) {
            //            parentRow.addClass("contact-selected");
            //            this.lastSelectedContactRow = parentRow;
            //        }

            //        this.currentLetterEntryContact = contactId;
            //        this.contacts_ShowLetterTypeEntry(businessUnitId, contactId);
            //    }

            //});

            //$("#businessUnitAddToClient").on("click", (e) => {
            //    e.preventDefault();
            //    const form = $("#" + this.detailContentContainer).find("form");
            //    const title = form.data("confirm-title");
            //    const msg = form.data("copy-businessUnit-msg");
            //    const id = form.find("#BusinessUnitID").val();

            //    cpiConfirm.confirm(title, msg, function () {
            //        const baseUrl = $("body").data("base-url");
            //        const url = `${baseUrl}/Shared/BusinessUnit/AddBusinessUnitToClient`;

            //        $.post(url, { id: id })
            //            .done(function () {
            //                $("#businessUnitAddToClient").addClass("d-none");
            //                pageHelper.showSuccess(form.data("copy-success-msg"));
            //            })
            //            .fail(function (e) {
            //                pageHelper.showErrors(e.responseText);
            //            });
            //    });
            //});
        });
    }


    valueMapper = (options, url) => {
        if (!url)
            url = $("body").data("base-url") + "/Shared/BusinessUnit/ValueMapper";

        $.ajax({
            url: url,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });
    }

    businessUnitCodeNameValueMapper = (options, url) => {
        if (!url)
            url = $("body").data("base-url") + "/Shared/BusinessUnit/BusinessUnitCodeNameValueMapper";

        $.ajax({
            url: url,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });
    }

    //deleteContactRow = (e, row) => {
    //    if (!this.businessUnitContactLetterEditMode) {
    //        this.deleteGridRow(e, row);
    //    }
    //}

    //contacts_ShowLetterTypeEntry = (businessUnitId, contactId) => {
    //    $(`#${this.businessUnitContactLettersContainer}`).show();
    //    this.contactLettersFilter = { EntityType: "O", EntityId: businessUnitId, ContactId: contactId };
    //    const businessUnitContactLettersGrid = $("#businessUnitContactLettersGrid").data("kendoGrid");
    //    businessUnitContactLettersGrid.dataSource.read();
    //}

    //contacts_onRowSelect = (row) => {
    //    if (!this.businessUnitContactLetterEditMode) {
    //        $(`#${this.businessUnitContactLettersContainer}`).hide();
    //        //const data = row.sender.dataItem(row.sender.select());
    //        //if (data.GenAllLetters !== 2) {
    //        //}
    //    }
    //    else {
    //        $(this.lastSelectedContactRow).addClass("k-state-selected");
    //    }
    //}

    //contacts_updateName = (property, value, id) => {
    //    this.lastSelectedContact[property] = value;
    //    this.lastSelectedContact.dirty = true;
    //    if (id > 0)
    //        this.lastSelectedContact.ContactID = id;
    //}

    //contacts_onEdit = (e) => {
    //    const selected = e.sender.select();
    //    if (selected && selected.length > 0)
    //        this.lastSelectedContact = e.sender.dataItem(selected);
    //    else
    //        this.lastSelectedContact = e.sender.dataSource._data[0];

    //    if (this.businessUnitContactLetterEditMode) {
    //        e.sender.closeCell();
    //        e.preventDefault();
    //    }
    //}

    //letters_onEdit = (e) => {
    //    const selected = e.sender.select();
    //    if (selected && selected.length > 0)
    //        this.lastSelectedLetter = e.sender.dataItem(selected);
    //    else
    //        this.lastSelectedLetter = e.sender.dataSource._data[0];
    //}

    //letters_updateName = (property, value) => {
    //    this.lastSelectedLetter[property] = value;
    //}

    ////hide letter settings if contact is deleted
    //contacts_onRemove() {
    //    $("#businessUnitContactLetters").hide();
    //}

    //contacts_resetEditedFlag = () => {
    //    this.businessUnitContactLetterEditMode = false;
    //    this.currentLetterEntryContact = 0;
    //}

    //getContactLettersFilter = () => {
    //    return { contactLettersFilter: this.contactLettersFilter };
    //}


    //copyToClient() {
    //    const copyForm = $("#copyToClient");
    //    copyForm.unbind("submit"); //clear previously attached submit handler

    //    copyForm.on("submit", function (e) {
    //        e.preventDefault();
    //        const params = copyForm.serialize();
    //        $.post(copyForm.attr("action"), params)
    //            .done(function () {
    //                $("#businessUnitCopyToClient").hide();
    //            })
    //            .fail(function (error) {
    //                page.showErrors(error.responseText);
    //            });
    //    });
    //    $(copyForm).submit();
    //}

}
//TN 20221116